import Add20 from '@carbon/icons-react/es/add/20';
import { Tabs as AntTabs } from 'antd';
import { TabsProps } from 'antd/es/tabs';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { IconShell } from 'components/atoms/icon-shell';
import { SingleLineEllipsis } from 'components/styles';

interface CustomTabsProps extends TabsProps {
  canRemove: boolean;
}
const CustomTabs: FC<CustomTabsProps> = (props) => (
  <AntTabs
    addIcon={<IconShell icon={<Add20 />} />}
    type="editable-card"
    hideAdd
    {...props}
  />
);

const StyledTabs = styled(CustomTabs)`
  --tab-width: 10rem;
  .ant-tabs-nav-wrap {
    border-bottom: 1px solid var(--border-color);
  }

  &.ant-tabs-card {
    .ant-tabs-top > .ant-tabs-nav .ant-tabs-tab {
      border-radius: 0;
    }

    > .ant-tabs-nav {
      height: 40px;

      .ant-tabs-tab {
        border: none;
        border-bottom: 2px solid transparent;
        max-width: var(--tab-width);
        width: var(--tab-width);

        &.ant-tabs-tab-active {
          background: unset;
          border-bottom: 2px solid var(--primary-color);
        }

        > .ant-tabs-tab-btn {
          ${SingleLineEllipsis};
        }

        .ant-tabs-tab-remove {
          display: none;
          ${({ canRemove }) =>
            canRemove &&
            css`
              display: unset;
            `};
        }
      }

      .ant-tabs-nav-add {
        border: none;
        padding: 0;
        &:hover {
          background-color: var(--hover-color);
        }
      }
    }
  }
`;

const { TabPane } = AntTabs;

type Tabs = typeof StyledTabs & {
  TabPane: typeof TabPane;
};

const Tabs: Tabs = StyledTabs as any;

Tabs.TabPane = TabPane;

export { Tabs };
